import {
  FETCH_CALENDAR_EVENTS_REQUEST,
  FETCH_CALENDAR_EVENTS_SUCCESS,
  FETCH_CALENDAR_EVENTS_FAILURE,
  FETCH_EVENT_CATEGORIES_REQUEST,
  FETCH_EVENT_CATEGORIES_SUCCESS,
  FETCH_EVENT_CATEGORIES_FAILURE,
} from "./actionTypes";

const initialState = {
  loading: false,
  venues_list: [],
  totalItems: 0,
  totalPages: 0,
  currentPage: 1,
  itemsPerPage: 10,
  error: "",
  // New fields for event categories
  event_categories: [],
  categoriesLoading: false,
  categoriesError: "",
};

const CalanderReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CALENDAR_EVENTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case FETCH_CALENDAR_EVENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        venues_list: action?.payload?.data?.data || [],
        totalItems: action?.payload?.data?.total || 0,
        totalPages: action?.payload?.data?.last_page || 0,
        currentPage: action?.payload?.data?.current_page || 1,
        itemsPerPage: action?.payload?.data?.per_page || 10,
        error: "",
      };

    case FETCH_CALENDAR_EVENTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload || "Failed to fetch calendar events",
      };

    //  NEW: Event Categories
    case FETCH_EVENT_CATEGORIES_REQUEST:
      return {
        ...state,
        categoriesLoading: true,
        categoriesError: "",
      };

    case FETCH_EVENT_CATEGORIES_SUCCESS:
      return {
        ...state,
        categoriesLoading: false,
        event_categories: action.payload.data || [],
      };

    case FETCH_EVENT_CATEGORIES_FAILURE:
      return {
        ...state,
        categoriesLoading: false,
        categoriesError: action.payload || "Failed to fetch event categories",
      };

    default:
      return state;
  }
};

export default CalanderReducer;
